import type { SVGProps } from 'react';

const PptIcon = (props: SVGProps<SVGSVGElement>) => (
   <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <path
         d="M3 3V29C3 30.6569 4.34315 32 6 32H26C27.6569 32 29 30.6569 29 29V12L17 0H6C4.34315 0 3 1.34315 3 3Z"
         fill="#FFDB8C"
      />
      <path d="M17 0L29 12H20C18.3431 12 17 10.6569 17 9V0Z" fill="#D99B2E" />
      <path
         d="M9.59863 22.5V25H8.16309V17.8906H10.585C11.2881 17.8906 11.848 18.1087 12.2646 18.5449C12.6846 18.9811 12.8945 19.5475 12.8945 20.2441C12.8945 20.9408 12.6878 21.4909 12.2744 21.8945C11.861 22.2982 11.2881 22.5 10.5557 22.5H9.59863ZM9.59863 21.3037H10.585C10.8584 21.3037 11.07 21.2142 11.2197 21.0352C11.3695 20.8561 11.4443 20.5957 11.4443 20.2539C11.4443 19.8991 11.3678 19.6175 11.2148 19.4092C11.0618 19.1976 10.8568 19.0902 10.5996 19.0869H9.59863V21.3037ZM15.292 22.5V25H13.8564V17.8906H16.2783C16.9814 17.8906 17.5413 18.1087 17.958 18.5449C18.3779 18.9811 18.5879 19.5475 18.5879 20.2441C18.5879 20.9408 18.3812 21.4909 17.9678 21.8945C17.5544 22.2982 16.9814 22.5 16.249 22.5H15.292ZM15.292 21.3037H16.2783C16.5518 21.3037 16.7633 21.2142 16.9131 21.0352C17.0628 20.8561 17.1377 20.5957 17.1377 20.2539C17.1377 19.8991 17.0612 19.6175 16.9082 19.4092C16.7552 19.1976 16.5501 19.0902 16.293 19.0869H15.292V21.3037ZM24.1543 19.0869H22.3965V25H20.9561V19.0869H19.2275V17.8906H24.1543V19.0869Z"
         fill="#66390C"
      />
   </svg>
);

export default PptIcon;
